import React, { Component, Fragment } from "react";
import Index from "../../../Components/Educacao/Index";

export default class PageIndex extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas"
        }
    }

    render() {
        return(
            <Fragment>
                <Index />
            </Fragment>
        )
    }
}